import { api } from './client';
import type {
  CreateProjectRequest,
  CreateSectionRequest,
  ProjectDto,
  SectionDto,
  UpdateProjectRequest
} from './types';

export function listProjects(workspaceId: string): Promise<ProjectDto[]> {
  return api<ProjectDto[]>(`/workspaces/${workspaceId}/projects`);
}

export function createProject(workspaceId: string, body: CreateProjectRequest): Promise<ProjectDto> {
  return api<ProjectDto>(`/workspaces/${workspaceId}/projects`, { method: 'POST', body });
}

export function updateProject(projectId: string, body: UpdateProjectRequest): Promise<ProjectDto> {
  return api<ProjectDto>(`/projects/${projectId}`, { method: 'PATCH', body });
}

export function setProjectShares(projectId: string, userIds: string[]): Promise<ProjectDto> {
  return api<ProjectDto>(`/projects/${projectId}/shares`, { method: 'PUT', body: { userIds } });
}

export function deleteProject(projectId: string): Promise<void> {
  return api<void>(`/projects/${projectId}`, { method: 'DELETE' });
}

export function createSection(projectId: string, body: CreateSectionRequest): Promise<SectionDto> {
  return api<SectionDto>(`/projects/${projectId}/sections`, { method: 'POST', body });
}

export function updateSection(
  sectionId: string,
  body: { name?: string; position?: number }
): Promise<SectionDto> {
  return api<SectionDto>(`/sections/${sectionId}`, { method: 'PATCH', body });
}

export function deleteSection(sectionId: string): Promise<void> {
  return api<void>(`/sections/${sectionId}`, { method: 'DELETE' });
}
